import type { TouchEvent } from "react";
import { iosDismissKeyboard } from "./ios";
import { androidDismissKeyboard } from "./android";

/**
 * Scroll-to-dismiss for the native keyboard, as an `onTouchMove` handler: a
 * drag puts the keyboard away. On iOS it is `endEditing`, which blurs the
 * field; on Android it is `hideSoftInputFromWindow`, which keeps the focus.
 * A drag on the focused field is a text gesture (caret, selection, scroll of
 * a long textarea) and keeps the keyboard. A surface whose text gestures start
 * around its field stops `touchmove` itself (see ChatInput).
 */
export function dismissNativeKeyboardOnDrag(e: TouchEvent): void {
  if (e.target === document.activeElement) return;
  void iosDismissKeyboard();
  void androidDismissKeyboard();
}
